import { useState, useEffect } from "react";
import legalService from "../services/legalService";

/**
 * Custom hook to fetch a legal page by type.
 * @param {'privacy-policy' | 'terms-of-service' | 'cookie-policy'} type
 * @returns {{ page: object|null, loading: boolean, error: string|null, refetch: Function }}
 */
export default function useLegalPage(type) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPage = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await legalService.getPage(type);
      if (result.success && result.page) {
        setPage(result.page);
      } else {
        setError(result.message || "Failed to load page");
      }
    } catch (err) {
      setError(err.message || "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await legalService.getPage(type);
        if (!cancelled) {
          if (result.success && result.page) {
            setPage(result.page);
          } else {
            setError(result.message || "Failed to load page");
          }
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "An unexpected error occurred");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [type]);

  return { page, loading, error, refetch: fetchPage };
}
